import LoadingScreen from "../../../ui/loadingScreen/LoadingScreen";
import { formatReceivedAt } from "../../../utils/formatReceivedAt";

import WhatsAppComposer from "./WhatsAppComposer";
import WhatsAppMessageList from "./WhatsAppMessageList";
import { threadTitle } from "./WhatsAppThreadList";

import styles from "./LeadWhatsApp.module.css";

export const windowStatusLabel = (thread) => {
  if (!thread) return "";
  if (thread.window_open && thread.window_closes_at) {
    return `Podés responder hasta ${formatReceivedAt(thread.window_closes_at)}`;
  }
  if (thread.window_open) return "Ventana de respuesta abierta";
  return thread.last_inbound_at
    ? "Ventana de respuesta cerrada"
    : "Esperando la primera respuesta del contacto";
};

const WhatsAppConversation = ({
  thread,
  messages = [],
  loading = false,
  error = null,
  hasMore = false,
  loadingOlder = false,
  onLoadOlder,
  onSend,
  onSendMedia,
  sending = false,
  sendError = null,
  onClearSendError,
  composerActions = null,
  overlay = null,
  renderMedia,
}) => {
  if (!thread) {
    return (
      <section className={styles.conversationPanel}>
        <div className={styles.emptyState}>
          Elegí una conversación o iniciá una nueva.
        </div>
      </section>
    );
  }

  const number = thread.whatsapp_account?.display_phone_number;

  return (
    <section className={styles.conversationPanel}>
      <header className={styles.conversationHeader}>
        <div className={styles.conversationHeaderContent}>
          <h3 className={styles.conversationTitle}>{threadTitle(thread)}</h3>
          <p className={styles.conversationSubtitle}>
            {thread.contact_phone}
            {number ? ` · desde ${number}` : ""}
          </p>
        </div>
        <span
          className={`${styles.windowChip} ${
            thread.window_open ? styles.windowChipOpen : styles.windowChipClosed
          }`}
        >
          {windowStatusLabel(thread)}
        </span>
      </header>

      <div className={styles.conversationBody}>
        {overlay ? (
          overlay
        ) : loading ? (
          <LoadingScreen embedded mainText="Cargando conversación..." subText="" />
        ) : error ? (
          <div className={styles.emptyState}>{error}</div>
        ) : (
          <WhatsAppMessageList
            messages={messages}
            hasMore={hasMore}
            loadingOlder={loadingOlder}
            onLoadOlder={onLoadOlder}
            renderMedia={renderMedia}
          />
        )}
      </div>

      <WhatsAppComposer
        accountId={thread?.whatsapp_account?.account ?? null}
        thread={thread}
        onSend={onSend}
        onSendMedia={onSendMedia}
        sending={sending}
        error={sendError}
        onClearError={onClearSendError}
        disabled={loading}
        extraActions={composerActions}
      />
    </section>
  );
};

export default WhatsAppConversation;
